import { InjectionToken, type Signal } from '@angular/core';

/**
 * Los números que el menú muestra al lado de un ítem.
 *
 * **Por qué un token y no una consulta en el shell.** El badge de Eventos es
 * "cuántos eventos de alumbrado están abiertos", y eso es una pregunta de
 * dominio: el shell vive en `ui/`, que por regla de capas no conoce ninguna
 * entidad de negocio. Con el token, el shell pide "el número de esta ruta" y
 * quien lo sabe es el dominio, cableado en `app.config.ts`.
 *
 * La clave es la ruta del ítem del menú, para no inventar un identificador más.
 */
export type ContadoresMenu = Record<string, Signal<number>>;

export const CONTADORES_MENU = new InjectionToken<ContadoresMenu>('contadores del menú', {
  factory: () => ({}),
});
